<div
  class="operation-inner"
  *ngFor="let operationFormGroup of operationsFormArray.controls; let i = index; trackBy: trackByValue"
>
  <y42-operation-input-date-time-form-group
    class="contents"
    [form]="operationFormGroup"
    [index]="i"
    [showRelativeDates]="showRelativeDates"
    [columnType]="columnType"
    [absoluteRanges]="absoluteRangePresets"
    [relativeRanges]="relativeRangePresets"
    [enableMoreConditions]="enableMoreConditions"
    [operatorOptions]="operatorOptions"
    [minDate]="minDate"
    [maxDate]="maxDate"
  ></y42-operation-input-date-time-form-group>
</div>
